/**
 * Status of a judge assignment
 */
export var CompetitionJudgeStatus;
(function (CompetitionJudgeStatus) {
    CompetitionJudgeStatus["PENDING"] = "PENDING";
    CompetitionJudgeStatus["APPROVED"] = "APPROVED";
    CompetitionJudgeStatus["REJECTED"] = "REJECTED";
    CompetitionJudgeStatus["REVOKED"] = "REVOKED";
})(CompetitionJudgeStatus || (CompetitionJudgeStatus = {}));
/**
 * Judge role within a competition/event
 */
export var JudgeRole;
(function (JudgeRole) {
    JudgeRole["SCORE_JUDGE"] = "SCORE_JUDGE";
    JudgeRole["HEAD_JUDGE"] = "HEAD_JUDGE";
    JudgeRole["ASSISTANT"] = "ASSISTANT";
})(JudgeRole || (JudgeRole = {}));
/**
 * Scope of judge assignment
 */
export var JudgeAssignmentScope;
(function (JudgeAssignmentScope) {
    JudgeAssignmentScope["EVENT"] = "EVENT";
    JudgeAssignmentScope["COMPETITION"] = "COMPETITION";
})(JudgeAssignmentScope || (JudgeAssignmentScope = {}));
//# sourceMappingURL=judge.js.map